import { render, staticRenderFns } from "./QuestionPhoneNumber.vue?vue&type=template&id=21b1515c&scoped=true&"
import script from "./QuestionPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./QuestionPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPhoneNumber.vue?vue&type=style&index=0&id=21b1515c&lang=scss&scoped=true&"
import style1 from "./QuestionPhoneNumber.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b1515c",
  null
  
)

export default component.exports